const Content = () => import(/* webpackChunkName: "content" */ '@/views/private/content/Index.vue')
const Article = () => import(/* webpackChunkName: "contentarticle" */ '@/components/content/Article.vue')
const Guide = () => import(/* webpackChunkName: "contentnews" */ '@/components/content/News.vue')
const Event = () => import(/* webpackChunkName: "contentevent" */ '@/components/content/Event.vue')
const Cast = () => import(/* webpackChunkName: "contentcast" */ '@/components/content/Cast.vue')

const routes = [
  {
    path: "/content",
    name: "content",
    component: Content,
    meta: {
      title: "Konten"
    },
    children: [
      {
        path: '/content/article',
        name: 'content article',
        component: Article,
        meta: {
          title: "Konten Artikel"
        }
      },
      {
        path: '/content/guide',
        name: 'content guide',
        component: Guide,
        meta: {
          title: "Konten Panduan BK"
        }
      },
      {
        path: '/content/event',
        name: 'content event',
        component: Event,
        meta: {
          title: "Konten Agenda"
        }
      },
      {
        path: '/content/cast',
        name: 'content cast',
        component: Cast,
        meta: {
          title: "Konten Cast"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})